import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormStateContext,
  useFormValidation,
} from 'ui'
import {
  BuyAndWindEffectKeys,
  type BuyAndWinEffect as BuyAndWinEffectType,
} from '../../../../typings'
import { BuyAndWinBenefitView } from './Benefit/View'
import { messages } from './messages'
import { BuyAndWinTriggerView } from './Trigger/View'
import { benefitSuite, triggerSuite } from './validation'

type BuyAndWinProps = {
  name: string
}

export function BuyAndWinEffect(props: BuyAndWinProps) {
  const { form } = useFormStateContext()
  const { name } = props

  const buyAndWinConfig: BuyAndWinEffectType = useWatch({ form, name })

  const { trigger } = buyAndWinConfig

  const triggerName = `${name}.${BuyAndWindEffectKeys.TRIGGER}`
  const benefitName = `${name}.${BuyAndWindEffectKeys.BENEFIT}`

  const validation = (config: BuyAndWinEffectType, { intl }) => {
    triggerSuite(intl, triggerName)(config[BuyAndWindEffectKeys.TRIGGER])
    benefitSuite(intl, benefitName)(config[BuyAndWindEffectKeys.BENEFIT])
  }

  useFormValidation('buy-and-win-effect', {
    fieldName: name,
    validateFn: validation,
  })

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage {...messages.title} />
        </SectionTitle>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <BuyAndWinTriggerView
          name={triggerName}
          config={trigger}
          onChange={(config) => form.setValue(triggerName, config)}
        />
        <BuyAndWinBenefitView
          name={benefitName}
          onChange={(config) => form.setValue(benefitName, config)}
        />
      </SectionContent>
    </Section>
  )
}
